/**
 * Session notes API service.
 *
 * Collaborative notes  → /api/protected/sessions/{id}/notes
 * Personal (private)   → /api/protected/sessions/{id}/notes/personal
 */

import { apiFetchJson } from "./apiClient";

export interface SessionNoteResponse {
  session_id: number;
  /** Note content (plain text or Markdown) */
  content: string;
  /** Username of the last person to edit the shared notes */
  updated_by: string;
  updated_at: string | null;
}

export interface PersonalNoteResponse {
  session_id: number;
  content: string;
  updated_at: string | null;
}

export const notesService = {
  /** Fetch the shared collaborative notes for a session. */
  getSessionNotes(sessionId: string): Promise<SessionNoteResponse> {
    return apiFetchJson<SessionNoteResponse>(`/api/protected/sessions/${sessionId}/notes`);
  },

  /** Save / update the shared collaborative notes. */
  updateSessionNotes(sessionId: string, content: string): Promise<SessionNoteResponse> {
    return apiFetchJson<SessionNoteResponse>(`/api/protected/sessions/${sessionId}/notes`, {
      method: "PUT",
      body: JSON.stringify({ content }),
    });
  },

  /** Fetch the current user's private notes for a session. */
  getPersonalNotes(sessionId: string): Promise<PersonalNoteResponse> {
    return apiFetchJson<PersonalNoteResponse>(
      `/api/protected/sessions/${sessionId}/notes/personal`
    );
  },

  /** Save / update the current user's private notes. */
  updatePersonalNotes(sessionId: string, content: string): Promise<PersonalNoteResponse> {
    return apiFetchJson<PersonalNoteResponse>(
      `/api/protected/sessions/${sessionId}/notes/personal`,
      { method: "PUT", body: JSON.stringify({ content }) }
    );
  },
};
